import React from 'react';
import styled from 'styled-components';
import { Section, Container } from '../layout';
import { Title, Header, Paragraph } from '../typography';
import { FadeIn } from '../animations';

interface ThinTextSectionProps {
    backgroundColor?: string;
    title: string;
    header: string;
    headerHighlight?: string;
    paragraph: string;
}

const TextContent = styled.div`
    text-align: center;
    color: ${({ theme }) => theme.colors.text};
    max-width: 700px;
    margin: 0 auto;
`;

export const ThinTextSection: React.FC<ThinTextSectionProps> = ({
    backgroundColor,
    title,
    header,
    headerHighlight,
    paragraph,
}) => {
    return (
        <Section backgroundColor={backgroundColor} thin>
            <Container narrow>
                <TextContent>
                    <FadeIn delay={0}>
                        <Title>{title}</Title>
                    </FadeIn>
                    <FadeIn delay={200}>
                        <Header highlightText={headerHighlight}>{header}</Header>
                    </FadeIn>
                    <FadeIn delay={400}>
                        <Paragraph>{paragraph}</Paragraph>
                    </FadeIn>
                </TextContent>
            </Container>
        </Section>
    );
};
